(() => {
  const merchantScriptUrl = 'https://checkout-merchant.snapmint.com/js/v1/8515';
  const merchantScriptSelector = 'script[src*="checkout-merchant.snapmint.com/js/v1/8515"]';

  const ensureSnapmintScript = () => {
    if (document.querySelector(merchantScriptSelector)) return;

    const script = document.createElement('script');
    script.src = merchantScriptUrl;
    script.defer = true;
    script.dataset.jwcSnapmintFallback = 'true';
    document.body.appendChild(script);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSnapmintScript, { once: true });
  } else {
    ensureSnapmintScript();
  }
})();
